<script>
    export default {
        props: {
            text: null,
        },
        data() {
            return {
                showText: false,
            }
        }
    }
</script>

<template>
    <span class="global-search-bar-info">
        <i class="fa fa-question-circle" @mouseenter="showText = true" @mouseleave="showText = false"></i>
        <span class="text" v-show="showText" v-html="text"></span>
    </span>
</template>